import { render, staticRenderFns } from "./ChildRecord.vue?vue&type=template&id=261e8156&scoped=true&"
import script from "./ChildRecord.vue?vue&type=script&lang=js&"
export * from "./ChildRecord.vue?vue&type=script&lang=js&"
import style0 from "./ChildRecord.vue?vue&type=style&index=0&id=261e8156&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261e8156",
  null
  
)

export default component.exports